import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BannerModule } from '@design/layout/banner-layout/banner.module';
import { IconComponent } from '@design/buttons/icon/icon.component';
import { TestIdDirective } from '@design/core/test-id.directive';

@Component({
  selector: 'app-lost-phone-banner',
  templateUrl: './lost-phone-banner.component.html',
  styleUrl: './lost-phone-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [BannerModule, IconComponent]
})
export class LostPhoneBannerComponent {
  constructor() {}
}
